import React, { useEffect, useState } from "react";
import locked from "../../../../../assets/img/locked.png";
import gift_box from "../../../../../assets/img/gift_box.png";
import old from "../../../../../assets/img/old.png";
import upi_redeem from "../../../../../assets/img/upi_redeem.png";
import ele_redeem from "../../../../../assets/img/ele_redeem.png";
//import unlocked from "../../../../../assets/img/unlocked.png";
import "./Redeemption.css"; // 👈 put the CSS here (see below)
import Navbar from "../../../../common/Navbar";
import * as Constants from "../../../../../Constants/index";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Oval from "../../../loader/CircleLoade";
import swal from "sweetalert";

/**
 * Sintex Rewards – Dashboard + Choose Redemption (responsive)
 */
const Redeemption = () => {
  const [screen, setScreen] = useState("dashboard"); // "dashboard" | "redemption"

  const showRedemptionScreen = () => setScreen("redemption");
  const showDashboardScreen = () => setScreen("dashboard");
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const [evgurl, setEvgurl] = useState("");
  const [loading, setLoading] = useState(false);
  const [profileDate, setProfileDate] = useState({});

  const getEVGUrl = async () => {
    if (!token) {
      navigate("/");
    } else {
      await axios
        .post(
          `${Constants.baseUrl}web/evg/view_url`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Accept-Language": localStorage.getItem("langauge"),
              appVersion: Constants.av,
              platform: Constants.pt,
              company: Constants.company,
              program: Constants.program,
            },
          }
        )
        .then((res) => {
          const dt = res.data;
          if (dt.result === "success") {
            setEvgurl(dt?.output?.url);
          }
        })
        .catch((err) => { });
    }
  };

  const handleVoucherClick = () => {
    if (evgurl) {
      window.open(evgurl, "_blank"); // 👉 opens in new tab
    }
  };

  useEffect(() => {
    getEVGUrl();
    profileReq();
  }, []);

  const profileReq = async () => {
    let token = localStorage.getItem("token");
    setLoading(true);
    if (!token) {
      navigate("/");
    } else {
      try {
        await axios
          .post(
            Constants.baseUrl + `auth/profile/get`,
            {},
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Accept-Language": localStorage.getItem("langauge"),
                appVersion: Constants.av,
                platform: Constants.pt,
              },
            }
          )
          .then((res) => {
            if (res.status === 200) {
              if (res.data.code === 10001) {
                setProfileDate(res.data.output);
                setLoading(false);
                console.log(profileDate);
              } else if (res.data.code === 12002) {
                setLoading(false);
              } else {
                swal({
                  text: res.data.msg,
                  // icon: 'error',
                  timer: 2000,
                  buttons: false,
                });
              }
            } else {
              swal({
                text: res.data.msg,
                // icon: 'error',
                timer: 2000,
                buttons: false,
              });
            }
          });
      } catch (error) {
        console.log(error);
      }
    }
  };

  const cPoints = Number(profileDate?.points || 0);
  const cNewPoints = Number(profileDate?.newPoints || 0);
  const cRedeemedPoints = Number(profileDate?.redeemedPoints || 0);
  const cUpiRedeemedPoints = Number(profileDate?.upiRedeemedPoints || 0);

  const redeemablePoints = cPoints + cNewPoints;
  const redeemedPoints = cRedeemedPoints + cUpiRedeemedPoints;

  return (

    <>
      {/* HEADER */}
      {loading ? <Oval /> : null}
      <Navbar />

      {/* SCREEN 1: DASHBOARD */}
      {screen === "dashboard" && (
        <div id="dashboardScreen" className="screen active">
          <section className="hero-dashboard container-fluid">
            {/* <div>
              <h1>Rewards Dashboard</h1>
              <p>Your Total Points</p>
            </div> */}
            {/* <div>
              <h1>Redeemable Points</h1>
              { redeemablePoints.toLocaleString() } pts
            </div> */}
            <div>
              <h1>Redeemable Points</h1>
              <h2 className="text-danger text-center">{ redeemablePoints.toLocaleString() } pts</h2>
            </div>
            <div>
              <h1>Redeemed Points</h1>
              <h2 className="text-danger text-center">{ redeemedPoints.toLocaleString() } pts</h2>
            </div>
          </section>

          <main className="dashboard-main container">
            {/* Locked card */}
            <section className="card locked-box">
              <div className="card-header">
                <div className="card-title"><img src={ele_redeem} alt=""  /> Unlocked</div>
                <div className="card-value">
                  {Number(profileDate?.unlockedPoints || 0).toLocaleString()} pts
                </div>

              </div>
              <div className="progress-bar-track">
                <div className="progress-bar-fill" />
              </div>
              <p className="muted">
                Unlocked {Number(profileDate?.unlockedPoints || 0).toLocaleString()} / {Number(profileDate?.lockedPoints || 0).toLocaleString()} only
              </p>

              <button className="pill-button" onClick={handleVoucherClick}>Redeem via voucher only</button>
            </section>

            {/* Old & New points cards */}
            <section className="cards-grid">
              <div className="card">
                <div className="card-header">
                  <div>
                    <div className="card-title">
                    <img src={old} alt="" height={20} width={20}  /> Old Points (Voucher Only)
                    </div>
                    <div className="muted">Earned on/before 31-Oct-25</div>
                  </div>
                </div>
                <div className="points-value">
                  {Number(profileDate?.points || 0).toLocaleString()} pts
                </div>

                <ul className="bullets">
                  <li>Earned on/before 31-Oct-25</li>
                  <li>Redeemable only as Vouchers</li>
                </ul>
                <button className="cta-button" onClick={handleVoucherClick}>
                  Redeem Voucher
                </button>
              </div>

              <div className="card">
                <div className="card-header">
                  <div>
                    <div className="card-title">
                    <img src={gift_box} alt="" height={20} width={20}  /> New Points (UPI &amp; Voucher)
                    </div>
                    <div className="muted">Earned on/after 1-Nov-25</div>
                  </div>
                </div>
                <div className="points-value">
                  {Number(profileDate?.newPoints || 0).toLocaleString()} pts
                </div>

                <ul className="bullets">
                  <li>Earned on/after 1-Nov-25</li>
                  <li>Redeemable via UPI and Vouchers</li>
                  <li>T.D.S : <b>{Number(profileDate?.tds || 0).toLocaleString()} pts</b></li>
                  <li>Total Earning So Far: <b>{Number(profileDate?.newTotalPoints || 0).toLocaleString()} pts</b></li>
                </ul>
                <button className="cta-button" onClick={showRedemptionScreen}>
                  Redeem via UPI &amp; Vouchers
                </button>
              </div>
            </section>
          </main>
        </div>
      )}

      {/* SCREEN 2: CHOOSE REDEMPTION */}
      {screen === "redemption" && (
        <div id="redemptionScreen" className="screen active">
          <section className="hero-choose container-fluid">
            <div className="title">Choose Redemption Type</div>
            <div className="subtitle">
              How would you like to redeem your points?
            </div>
          </section>

          <main className="choose-main container-fluid">
            <section className="options-grid">
              <div className="option-card">
                <div className="option-icon"><img src={upi_redeem} alt=""  /></div>
                <div className="option-title">UPI Redemption</div>
                <div className="option-desc">
                  Redeem your eligible points directly to your UPI ID as instant
                  cash credit.
                </div>
                <button className="option-cta" onClick={() => navigate("/upi_redeemption")}>Continue with UPI</button>
              </div>

              <div className="option-card">
                <div className="option-icon"><img src={ele_redeem} alt=""  /></div>
                <div className="option-title">
                  Redeem Electronic Gift Voucher
                </div>
                <div className="option-desc">
                  Convert your points into digital gift vouchers that can be
                  used at partner brands.
                </div>
                <button className="option-cta" onClick={handleVoucherClick}>Continue with e-Voucher</button>
              </div>
            </section>

            <div className="back-row">
              Not sure?{" "}
              <button
                type="button"
                className="back-link-button"
                onClick={showDashboardScreen}
              >
                Go back to Rewards Dashboard
              </button>
            </div>
          </main>
        </div>
      )}
    </>
  );
};

export default Redeemption;
